<template>
	<div
		class="dim"
		@click="$emit('onClick')"
	></div>
</template>

<script>
export default {};
</script>

<style>
.dim {
	position: fixed;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
	background: black;
	opacity: 0.6;
	z-index: 100;
}
</style>
